
import { Link } from 'react-router-dom';

const ServicesGrid = () => {
  const services = [
    {
      icon: 'ri-car-fill',
      title: 'Collision Repair',
      description: 'Expert collision repair services to restore your vehicle to pre-accident condition. We handle everything from minor fender benders to major collision damage with precision and care.',
      features: ['Frame Alignment', 'Structural Repair', 'Insurance Claims', 'Quality Guarantee']
    },
    {
      icon: 'ri-brush-fill',
      title: 'Auto Body Painting',
      description: 'Professional auto body painting with color-matching technology and premium finishes. Our state-of-the-art paint booth ensures a flawless, factory-quality finish every time.',
      features: ['Color Matching', 'Clear Coat Protection', 'Rust Prevention', 'Lifetime Warranty']
    },
    {
      icon: 'ri-hammer-fill',
      title: 'Dent Removal',
      description: 'Advanced paintless dent removal and traditional dent repair services. We remove dents, dings, and creases while preserving your original paint finish whenever possible.',
      features: ['Paintless Repair', 'Hail Damage', 'Door Dings', 'Quick Turnaround']
    },
    {
      icon: 'ri-tools-fill',
      title: 'Frame Straightening',
      description: 'Precision frame straightening using computerized measuring systems. We restore your vehicle\'s structural integrity and ensure proper alignment for safe driving.',
      features: ['Laser Measurement', 'Unibody Repair', 'Safety Certified', 'OEM Standards']
    },
    {
      icon: 'ri-settings-3-fill',
      title: 'Mechanical Services',
      description: 'Complete mechanical repair and maintenance services including engine diagnostics, brake repair, suspension work, and routine maintenance to keep your vehicle running smoothly.',
      features: ['Engine Repair', 'Brake Service', 'Oil Changes', 'Diagnostics']
    },
    {
      icon: 'ri-truck-fill',
      title: '24/7 Towing Service',
      description: 'Round-the-clock emergency towing and roadside assistance throughout Brooklyn and NYC. We\'re here when you need us most, day or night.',
      features: ['24/7 Availability', 'Emergency Towing', 'Roadside Help', 'Accident Recovery']
    }
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-600 px-4 py-2 rounded-full mb-4 sm:mb-6">
            <i className="ri-tools-fill text-lg"></i>
            <span className="text-sm font-semibold whitespace-nowrap">Our Services</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 font-['Playfair_Display'] px-4">
            Complete Auto Body & Collision Services
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
            From collision repair to routine maintenance, we provide comprehensive auto body services with expert craftsmanship and attention to detail. All work backed by our quality guarantee.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white border-2 border-gray-100 rounded-2xl p-6 sm:p-8 hover:border-orange-600 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-orange-100 rounded-2xl mb-4 sm:mb-6 group-hover:bg-orange-600 transition-colors">
                <i className={`${service.icon} text-2xl sm:text-3xl text-orange-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 font-['Playfair_Display']">
                {service.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                {service.description}
              </p>
              <ul className="space-y-2 sm:space-y-3 mb-6">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm sm:text-base text-gray-700">
                    <i className="ri-checkbox-circle-fill text-orange-600 text-base sm:text-lg"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <Link
                to="/services"
                className="inline-flex items-center gap-2 text-orange-600 font-semibold text-sm sm:text-base hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
              >
                Learn More
                <i className="ri-arrow-right-line text-lg"></i>
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-12 sm:mt-16">
          <Link
            to="/services"
            className="inline-flex items-center gap-3 bg-orange-600 hover:bg-orange-700 text-white px-8 sm:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold transition-all hover:scale-105 shadow-lg whitespace-nowrap"
          >
            View All Services
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
